import Axios from 'axios'

const config = { headers: { 'Content-Type': 'application/json' } }

const instanceMainService = Axios.create({ ...config, baseURL: process.env.REACT_APP_BACKEND_URL })

const instancePoapService = Axios.create({ ...config, baseURL: process.env.REACT_APP_POAP_SERVICE + '/api' })

export { instanceMainService, instancePoapService }
